import { render, staticRenderFns } from "./SelectCategorias.vue?vue&type=template&id=58463657"
import script from "./SelectCategorias.vue?vue&type=script&lang=js"
export * from "./SelectCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports